module.exports = __webpack_public_path__ + "img/wordmark_white.c01e3b47.svg";